import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listReservationAvailabilities } from './api';
import {
  LIST_RESERVATION_AVAILABILITIES_REQUEST,
  RESERVATION_AVAILABILITY_REQUESTING,
  LIST_RESERVATION_AVAILABILITIES_SUCCESS,
  RESET_RESERVATION_AVAILABILITY_ISFETCHING,
  LIST_RESERVATION_AVAILABILITIES_SUCCESS_GTM
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_AVAILABILITY_REQUESTING });
    let { queryString } = action;
    if (customerId()) {
      queryString += `&customerId=${customerId()}`;
    }
    const response = yield call(listReservationAvailabilities, queryString);
    yield put({
      type: LIST_RESERVATION_AVAILABILITIES_SUCCESS,
      payload: response.data
    });
    yield put({
      type: LIST_RESERVATION_AVAILABILITIES_SUCCESS_GTM,
      payload: response.data,
      viewType: action.viewType
    });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_AVAILABILITY_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_RESERVATION_AVAILABILITIES_REQUEST, list);
}

export default function* reservationAvailabilitySagas() {
  yield all([watchList()]);
}

const customerId = () => {
  if (!Cookies.get('customerToken')) {
    return null;
  }
  return jwtDecode(Cookies.get('customerToken')).sub;
};
